import { ServicesPreferencesModalData } from '@wix/bookings-services-preferences-modal/types';

export enum DialogType {
  Premium = 'premium',
  ServicePreferences = 'servicePreferences',
}
export interface PremiumDialogViewModel {
  type: DialogType;
  isOpen: boolean;
  data?: never;
  returnFocusOnDeactivate?: boolean;
}

export interface ServicePreferencesDialogViewModel {
  type: DialogType;
  data: ServicesPreferencesModalData;
  isOpen: boolean;
  returnFocusOnDeactivate?: boolean;
}

export type DialogViewModel =
  | PremiumDialogViewModel
  | ServicePreferencesDialogViewModel;

export const createDialogViewModel = ({
  type = DialogType.Premium,
  isOpen = false,
  data = undefined,
  returnFocusOnDeactivate = true,
}: Partial<DialogViewModel> = {}): DialogViewModel => {
  return {
    data: data as any,
    type,
    isOpen,
    returnFocusOnDeactivate,
  };
};
